import {dynamic} from '@github-ui/dynamic'

export const IssueRepoNewPage = dynamic(async () => {
  const module = await import('./pages/issue-new/IssueRepoNewPage')
  return {default: module.IssueRepoNewPage}
})

export const IssueRepoNewChoosePage = dynamic(async () => {
  const module = await import('./pages/issue-new/IssueRepoNewChoosePage')
  return {default: module.IssueRepoNewChoosePage}
})

export const IssueDashboardKnownViewPage = dynamic(async () => {
  const module = await import('./pages/IssueDashboardKnownViewPage')
  return {default: module.IssueDashboardKnownViewPage}
})

export const IssueShowPage = dynamic(async () => {
  const module = await import('./pages/IssueShowPage')
  return {default: module.IssueShowPage}
})

export const IssueIndexPage = dynamic(async () => {
  const module = await import('./pages/IssueIndexPage')
  return {default: module.IssueIndexPage}
})

export const IssueDashboardCustomViewPage = dynamic(async () => {
  const module = await import('./pages/IssueDashboardCustomViewPage')
  return {default: module.IssueDashboardCustomViewPage}
})

export const IssueViewsPage = dynamic(async () => {
  const module = await import('./pages/IssueViewsPage')
  return {default: module.IssueViewsPage}
})

export const RepositorySavedViewPage = dynamic(async () => {
  const module = await import('./pages/views-show/RepositorySavedViewPage')
  return {default: module.RepositorySavedViewPage}
})

export const RepositoryViewNewPage = dynamic(async () => {
  const module = await import('./pages/views-new/RepositoryViewNewPage')
  return {default: module.RepositoryViewNewPage}
})

export const IssueDashboardPage = dynamic(async () => {
  const module = await import('./pages/IssueDashboardPage')
  return {default: module.IssueDashboardPage}
})

// Milestone pages
export const RepositoryMilestonePage = dynamic(async () => {
  const module = await import('./pages/RepositoryMilestonePage')
  return {default: module.RepositoryMilestonePage}
})

// Projects pages
export const RepositoryProjectsPage = dynamic(async () => {
  const module = await import('./pages/RepositoryProjectsPage')
  return {default: module.RepositoryProjectsPage}
})
